<div class="p-3.5 relative flex flex-col h-full">
  <div
    class="flex mb-1"
    [ngClass]="{
      '-ml-1 -mr-1': isEditMode(),
    }"
  >
    @if (isEditMode()) {
      <i class="text-ui-gray-100 text-2xl icon-ic_drag-n-drop gridster-drag-handle"></i>
    }

    <div class="flex flex-1 flex-col overflow-hidden">
      @if (titleUrl()) {
        <a
          class="text-sm font-semibold text-ui-dark avs-truncate"
          [queryParams]="queryParams()"
          [routerLink]="titleUrl()"
        >
          <span class="hover:underline">
            {{ widget().config.name }}
          </span>
        </a>
      } @else {
        <span class="text-sm font-semibold text-ui-dark avs-truncate">
          {{ widget().config.name }}
        </span>
      }
      @if (widget().config.locationId) {
        <a
          class="hover:underline cursor-pointer avs-truncate"
          [queryParams]="queryParams()"
          [routerLink]="spaceUrl()"
        >
          <avs-li-space-location [config]="{
            locationId: widget().config.locationId,
            floorId: $any(widget().config).floorId,
            roomId: $any(widget().config).roomId
          }" />
        </a>
      }
    </div>

    @if (isEditMode()) {
      <div>
        <i
          class="icon-edit text-2xl action-icon mr-0"
          (click)="edit.emit(widget().id)"
          matTooltip="Edit Widget"
        ></i>
        <i
          class="icon-remove text-2xl action-icon"
          (click)="delete.emit(widget().id)"
          matTooltip="Remove Widget"
        ></i>
      </div>
    }
  </div>

  @if (isEditMode()) {
    <i class="icon-ic_rezise absolute bottom-0 right-0 text-ui-gray-100 z-[1]"></i>
  }

  <div
    class="flex flex-1 overflow-auto"
    [class]="[heightClassBreakpoint(), widthClassBreakpoint()]"
  >
    @switch (widget().config.type) {
      @case ('connectedDevices') {
        <avs-connected-devices
          class="widget"
          [config]="$any(widget().config)"
          #widgetRef
        />
      }
      @case ('buildingPlan') {
        <avs-building-plan
          class="widget"
          [config]="$any(widget().config)"
          #widgetRef
        />
      }
      @case ('dataPoint') {
        <avs-data-point
          class="widget"
          [config]="$any(widget().config)"
          #widgetRef
        />
      }
      @case ('deviceChart') {
        <avs-device-chart
          class="widget"
          [config]="$any(widget().config)"
          #widgetRef
        />
      }
      @case ('devices') {
        <avs-devices
          class="widget"
          [config]="$any(widget().config)"
          #widgetRef
        />
      }
      @case ('deviceStats') {
        <avs-device-stats
          class="widget"
          [config]="$any(widget().config)"
          #widgetRef
        />
      }
      @case ('map') {
        <avs-map
          class="widget"
          [config]="$any(widget().config)"
          #widgetRef
        />
      }
      @case ('roomState') {
        <avs-room-state
          class="widget"
          [config]="$any(widget().config)"
          #widgetRef
        />
      }
      @case ('spaceDetails') {
        <avs-space-details
          class="widget"
          [config]="$any(widget().config)"
          #widgetRef
        />
      }
      @case ('gauge') {
        <avs-gauge
          class="widget"
          [config]="$any(widget().config)"
          #widgetRef
        />
      }
    }
  </div>
</div>
